import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';

export var ReportTools = {
	
	viewReportDetails(detailHandler, unitsHandler, reportId, groupsHandler, companyId) {
		var reportCompanyId = companyId;

		var detailWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Details',
			icon: 'vaadin:modal-list',
			width: .75,
			height: .75,
			listeners: {
				ready: function () {
					detailWin.show();

					var detailTable = ElementUtil.create({
						tag: 'dl-detail-table',
						itemid: 'detailtable',
						slot: 'primary'
					});

					var updateDetails = function (detail) {
						if (!reportCompanyId && detail.reportHistory.companyId) {
							reportCompanyId = detail.reportHistory.companyId;
						}
						var data = [
							{
								key: 'Report',
								value: '-',
								section: true
							},
							{
								key: 'Report Id',
								value: detail.reportHistory.reportId
							},
							{
								key: 'User',
								value: detail.reportHistory.generatedForUser
							},
							{
								key: 'Report',
								value: detail.reportHistory.reportType
							},
							{
								key: 'Report Description',
								value: detail.reportHistory.reportTypeDescription
							},
							{
								key: 'Status',
								value: detail.reportHistory.runStatusDescription + (detail.reportHistory.statusExtraDetail ? ' (' + detail.reportHistory.statusExtraDetail + ')' : '')
							},
							{
								key: 'Unit Selection Type',
								value: detail.reportHistory.unitSelectionTypeDescription ? detail.reportHistory.unitSelectionTypeDescription : 'N/A'
							},
							{
								key: 'Expires in Days',
								value: detail.reportHistory.expiresInDays === -1 ? 'Never' : detail.reportHistory.expiresInDays
							},
							{
								key: 'Note',
								value: (detail.reportHistory.note ? detail.reportHistory.note : '')
							},
							{
								key: 'Finalized',
								value: detail.reportHistory.finalized
							},
							{
								key: 'Scheduled',
								value: detail.reportHistory.scheduled ? detail.reportHistory.scheduled + ' ' + detail.reportHistory.scheduledId : false
							},
							{
								key: 'Uploaded',
								value: detail.reportHistory.manualUploaded
							},
							{
								key: 'Report Data Start Date',
								value: detail.reportHistory.reportBeginDts ? TimeUtil.formatReportPeriodDate(detail.reportHistory.reportBeginDts, true) : "N/A"
							},
							{
								key: 'Report Data End Date',
								value: detail.reportHistory.reportEndDts ? TimeUtil.formatReportPeriodDate(detail.reportHistory.reportEndDts, false) : "N/A"
							},
							{
								key: 'Start Date',
								value: detail.reportHistory.startedDts ? TimeUtil.formatDateStandard(detail.reportHistory.startedDts) : "Not Started"
							},
							{
								key: 'Complete Date',
								value: detail.reportHistory.completedDts ? TimeUtil.formatDateStandard(detail.reportHistory.completedDts) : ""
							},
							{
								key: 'Create User',
								value: detail.reportHistory.createUser
							},
							{
								key: 'Create Date',
								value: TimeUtil.formatDateStandard(detail.reportHistory.createDts)
							},
							{
								key: 'Update User',
								value: detail.reportHistory.updateUser
							},
							{
								key: 'Last Update Date',
								value: TimeUtil.formatDateStandard(detail.reportHistory.updateDts)
							}
						];

						if (detail.reportHistory.summary && detail.reportHistory.summary.metaData) {
							data.push({
								key: 'Summary',
								value: '-',
								section: true
							});

							for (var key in detail.reportHistory.summary.metaData) {
								data.push({
									key: key,
									value: detail.reportHistory.summary.metaData[key]
								});
							}
						}

						if (!ElementUtil.isEmpty(detail.reportHistory.versions)) {
							data.push({
								key: 'Versions',
								value: '-',
								section: true
							});

							detail.reportHistory.versions.forEach(function (version) {
								data.push({
									key: version.componentName,
									value: version.version
								});
							});
						}

						//outputs
						data.push({
							key: 'Outputs',
							value: '-',
							section: true
						});
						detail.reportHistory.outputs.forEach(function (output) {
							if (output.uncompressSize && output.uncompressSize > 0) {
								data.push({
									key: 'Transmission Type',
									value: output.transmissionType
								});
								data.push({
									key: 'Format',
									value: output.format
								});
								data.push({
									key: 'Size',
									value: output.uncompressSize
								});

								if (output.transmissionType === 'FILE' || output.outputId) {
									data.push({
										key: 'Link',
										value: '<a href="#" onclick="window.DL.Service.getReportService().downloadReport(\'' + detail.reportHistory.reportId + '\', \'' + output.outputId + '\', \'' + reportCompanyId + '\');">Download</a>'
									});
								}

								data.push({
									key: 'Output Options',
									value: '-------------'
								});

								for (var key in output.options) {
									data.push({
										key: key,
										value: output.options[key]
									});
								}
							}
						});

						if (!ElementUtil.isEmpty(detail.reportHistory.options)) {
							data.push({
								key: 'Options',
								value: '-',
								section: true
							});

							for (var key in detail.reportHistory.options) {
								data.push({
									key: key,
									value: detail.reportHistory.options[key]
								});
							}
						}

						detailTable.updateDetails(data);

						//update error grid
						errorsGrid.items = detail.errors;
					};

					var detailedLayout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [
							detailTable
						]
					});

					var errorsGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true
						},
						children: [
							{
								path: 'typeDescription',
								header: 'Type',
								width: '7em'
							},
							{
								path: 'message',
								header: 'Message',
								width: '12em'
							}
						]
					});

					var errorFooter = ExportUtil.createExportFooter({
						grid: errorsGrid,
						itemid: 'report-errors',
						showDetail: false
					});

					var errorLayout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [
							errorsGrid,
							errorFooter.footerContainer
						]
					});

					var unitsGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true
						},
						children: [
							{
								path: 'referenceTypeDescription',
								header: 'Reference Type',
								width: '7em'
							},
							{
								path: 'referenceNo',
								header: 'Unit Reference No',
								width: '7em'
							},
							{
								path: 'unitId',
								header: 'Unit Id',
								width: '7em'
							},
							{
								path: 'reportingPeriods',
								header: 'Reporting Periods',
								width: '12em',
								renderer: function (root, column, rowData) {
									if (rowData.item.reportingPeriods && rowData.item.reportingPeriods.length > 0) {
										var timeperiods = [];
										rowData.item.reportingPeriods.forEach(function (rp) {
											var startDate = TimeUtil.parseDate(rowData.item.startDts);
											var endDate = TimeUtil.parseDate(rowData.item.endDts);
											timeperiods.push(
													'Start: ' + TimeUtil.formatDateStandard(startDate) + '<br>' +
													'End: ' + TimeUtil.formatDateStandard(endDate)
													);
										});

										root.innerHTML = timeperiods.join('<br><br>');
									} else {
										root.innerHTML = 'N/A';
									}
								}
							}
						]
					});

					var unitFilterToolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [
							{
								tag: 'vaadin-text-field',
								itemid: 'filterUnitRefNo',
								'class': 'spacer-toolbar-item',
								'keep-open': true,
								label: 'Unit Reference No',
								placeholder: 'Contains',
								listeners: {
									input: {
										fn: function () {
											unitPagingToolbar.loadCurrentPage();
										},
										buffer: 2000
									}
								}
							}
						]
					});

					var unitPagingToolbar = ElementUtil.create({
						tag: 'dl-paging-toolbar',
						slot: 'footer',
						pageSize: 50,
						postinit: function (element) {
							element.grid = unitsGrid;
							element.loader = function (backingGrid, pageNumber, pagebar) {
								var pageRange = pagebar.pullRange();
								var loadMask = unitsGrid.showLoading();

								var loadData = function () {

									unitsGrid.currentFilter = {
										offset: pageRange.offset,
										max: pageRange.max,
										sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
										sortOrder: backingGrid.currentSortDirection ? backingGrid.currentSortDirection : 'ASC',
										filterField: 'referenceNo',
										filterValue: ElementUtil.query(unitFilterToolbar, 'filterUnitRefNo').value
									};

									var successHandler = function (records) {
										loadMask.remove();
										unitsGrid.activeItem = null;
										unitsGrid.items = records.data;

										unitPagingToolbar.totalRecords = records.totalNumber;
										unitPagingToolbar.updatePager();
									};

									unitsHandler(successHandler, unitsGrid.currentFilter);
																		
								};

								loadData();
							};
						},
						listeners: {
							ready: function () {
								unitPagingToolbar.loadCurrentPage();
							}
						}

					});


					var unitFooter = ExportUtil.createExportFooter({
						pagingToolbar: unitPagingToolbar,
						grid: unitsGrid,
						itemid: 'report-units',
						onDetail: function() {
							var exportFilter = Object.assign({}, unitsGrid.currentFilter || {});
							delete exportFilter.offset;
							delete exportFilter.max;
							Service.getReportService().exportReportUnits(reportId, exportFilter, reportCompanyId);
						}
					});

					var unitLayout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [
							unitFilterToolbar,
							unitsGrid,
							unitFooter.footerContainer
						]
					});

					var groupsGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true
						},
						children: [
							{
								path: 'groupName',
								header: 'Group Name',
								flexGrow: 1
							},
							{
								path: 'groupCode',
								header: 'Group Code',
								width: '8em'
							},
							{
								path: 'tagExpression',
								header: 'Tag Expression',
								width: '12em'
							}
						]
					});

					var groupFilterToolbar = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [
							{
								tag: 'vaadin-text-field',
								itemid: 'filterGroupName',
								'class': 'spacer-toolbar-item',
								'keep-open': true,
								label: 'Group Name',
								placeholder: 'Contains',
								listeners: {
									input: {
										fn: function () {
											groupPagingToolbar.loadCurrentPage();
										},
										buffer: 2000
									}
								}
							}
						]
					});

					var groupPagingToolbar = ElementUtil.create({
						tag: 'dl-paging-toolbar',
						slot: 'footer',
						pageSize: 50,
						postinit: function (element) {
							element.grid = groupsGrid;
							element.loader = function (backingGrid, pageNumber, pagebar) {
								var pageRange = pagebar.pullRange();
								var loadMask = groupsGrid.showLoading();

								groupsGrid.currentFilter = {
									offset: pageRange.offset,
									max: pageRange.max,
									sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'groupName',
									sortOrder: backingGrid.currentSortDirection ? backingGrid.currentSortDirection : 'ASC',
									filterField: 'groupName',
									filterValue: ElementUtil.query(groupFilterToolbar, 'filterGroupName').value
								};

								var successHandler = function (records) {
									loadMask.remove();
									groupsGrid.activeItem = null;
									groupsGrid.items = records.data;

									groupPagingToolbar.totalRecords = records.totalNumber;
									groupPagingToolbar.updatePager();
								};

								if (typeof groupsHandler === 'function') {
									groupsHandler(successHandler, groupsGrid.currentFilter);
								} else {
									Service.getReportService().getReportBulkGroups(reportId, groupsGrid.currentFilter, reportCompanyId).then(function (records) {
										successHandler(records);
									});
								}
							};
						},
						listeners: {
							ready: function () {
								groupPagingToolbar.loadCurrentPage();
							}
						}
					});

					var groupFooter = ExportUtil.createExportFooter({
						pagingToolbar: groupPagingToolbar,
						grid: groupsGrid,
						itemid: 'report-bulk-groups',
						onDetail: function() {
							var exportFilter = Object.assign({}, groupsGrid.currentFilter || {});
							delete exportFilter.offset;
							delete exportFilter.max;
							Service.getReportService().exportReportBulkGroups(reportId, exportFilter, reportCompanyId);
						}
					});

					var groupLayout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [
							groupFilterToolbar,
							groupsGrid,
							groupFooter.footerContainer
						]
					});

					var tabPanel = ElementUtil.create({
						tag: 'dl-tabpanel',
						listeners: {
							ready: function (e) {
								tabPanel.addTabs([
									{
										'tab-title': 'Report',
										tag: 'div',
										style: 'height: 100%;',
										children: [
											detailedLayout
										]
									},
									{
										'tab-title': 'Units',
										tag: 'div',
										style: 'height: 100%;',
										children: [
											unitLayout
										]
									},
									{
										'tab-title': 'Groups',
										tag: 'div',
										style: 'height: 100%;',
										children: [
											groupLayout
										]
									},
									{
										'tab-title': 'Errors / Messages',
										tag: 'div',
										style: 'height: 100%;',
										children: [
											errorLayout
										]
									}
								]);
							}
						}
					});

					detailWin.addToContentElement(tabPanel);

					//pull Details
					detailHandler(updateDetails);
				}
			}
		});

	}
	
};


